import * as AssetDetailsActions from '../../state/asset-details/asset-details.actions';
import template from './asset-details-dashboard.component.html';

// Constants
const EVENT_TRACKING_NAME = 'assetDetailsDashboard';
const EVENT_TRACKING_ACTIONS = {
  showDateClicked: 'showDateClicked',
  pollCommandClicked: 'pollCommandClicked',
  editClicked: 'editClicked',
  refreshClicked: 'refreshClicked',
};

export class AssetDetailsDashboardController {
  constructor($scope, $stateParams, usersService, CommandsRepo, $ngRedux, $timeout) {
    'ngInject';
    this.store = $ngRedux;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.usersService = usersService;
    this.CommandsRepo = CommandsRepo;
    this.mapStateToThis = this.mapStateToThis.bind(this);

    this.showDate = false;
    this.timer = null;
    this.pollPending = false;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, { ...AssetDetailsActions })(this);
    //fire the action to get data
    this.getAssetData(this.$stateParams.equipmentId);
    this.updateBreadcrumbBar(this.$stateParams.title);
    this.hasImageFeature = this.usersService.hasRequiredFeatures(['images']);
    this.hasConfigCommandFeature = this.usersService.hasRequiredFeatures(['commands.configure']);
    this.hasDevices = this.usersService.hasRequiredFeatures(['devices']);
  }

  mapStateToThis(state) {
    const {
      refreshing,
      loading,
      asset,
      dataDateRange,
      seriesDataStatus,
      selectedSeriesIds,
      activeDataTap,
      error,
    } = state.asset_details;
    const { series = [], name, seriesData = {} } = asset || {};
    if (name) {
      this.updateBreadcrumbBar(name);
    }
    const chosenRunHours = series.find((ser) => ser.chosenRunHours);
    const setRunhoursAvailable =
      chosenRunHours &&
      chosenRunHours.dataId === asset.syncRunHours &&
      asset.hasSetAccumulatorCommand &&
      this.hasConfigCommandFeature;
    return {
      assetState: state.asset_details,
      refreshing,
      loading,
      asset: { ...asset },
      runHours: chosenRunHours,
      dataDateRange,
      detailsLoading: loading || refreshing,
      seriesDataStatus,
      selectedSeriesIds,
      activeDataTap,
      seriesData,
      error,
      setRunhoursAvailable: setRunhoursAvailable,
    };
  }

  $onDestroy() {
    this.unsubscribe();
    this.$timeout.cancel(this.timer);
  }

  addToDataLayer(data) {
    window.dataLayer.push({
      event: EVENT_TRACKING_NAME,
      data: { ...data },
    });
  }
  updateBreadcrumbBar(newName) {
    if (this.$scope.assetName !== newName) {
      this.$scope.assetName = newName;
      this.$scope.$emit('$viewContentLoaded'); //breadcrumb fix;
    }
  }
  toggleShowDate() {
    this.showDate = !this.showDate;
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.showDateClicked,
    });
  }

  sendPollCommand() {
    this.$timeout.cancel(this.timer);
    this.previousCommunicatedAt = this.asset.communicatedAt;
    this.pollPending = true;
    this.CommandsRepo.executeCommand(this.asset.id, 'poll')
      .then(() => this._scheduleRefresh())
      .catch(() => { this.pollPending = false; });
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.pollCommandClicked,
    });
  }

  _scheduleRefresh(attemptsLeft = 5) {
    if (attemptsLeft === 0) {
      this.pollPending = false;
      return;
    }
    this.refreshAssetdashBoardData(this.asset.id);
    this.timer = this.$timeout(() => {
      if (this.asset.communicatedAt !== this.previousCommunicatedAt) {
        this.pollPending = false;
        return;
      }
      this._scheduleRefresh(attemptsLeft - 1);
    }, 15000);
  }
  refreshData() {
    if (!this.refreshing) {
      this.refreshAssetdashBoardData(this.asset.id);

      this.addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.refreshClicked,
      });
    }
  }

  editButtonClicked() {
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.editClicked,
    });
  }
}

export default {
  template,
  controller: AssetDetailsDashboardController,
  controllerAs: 'vm',
  bindings: {},
};
